import React from 'react'
import HeaderStartupApproved from '../components/Header/HeaderStartupApproved/HeaderStartupApproved'
import HeaderStartupApprovedMobile from '../components/Header/HeaderStartupApprovedMobile/HeaderStartupApprovedMobile'
import useMediaQuery from 'use-mediaquery'
import { useState } from 'react'

const StartupApprovedLayout = ({ children, setIsFeePageActive }) => {
    const matches = useMediaQuery('(min-width: 768px)')
    const [isFeePageActive, setLocalIsFeePageActive] = useState(false)

    const setter = setIsFeePageActive || setLocalIsFeePageActive
    return (
        <div className='approved-layout'>
            <div className="sticky-top">
                <HeaderStartupApproved isFeePageActive={isFeePageActive} />
            </div>
            {/* {matches ? (
            ) : (
                <div className="d-block d-md-none sticky-top">
                    <HeaderStartupApprovedMobile isFeePageActive={isFeePageActive} />
                </div>
            )} */}
            <div className='approved-main'>
                <div className="approved-content">{
                    React.cloneElement(children, {
                        isFeePageActive,
                        setIsFeePageActive: setter
                    })
                }</div>
            </div>
        </div>
    )
}

export default StartupApprovedLayout